import React from 'react'


import Button from '@mui/material/Button';

function SeeMoreBtn({children}) {
  const [readMore, setReadMore] = React.useState(false)
  
  const text = children.substring(0, children.indexOf('.'))?children.substring(0, children.indexOf('.')):''
  console.log("content => ",text)

  const toggleReadBtn = () => {
    setReadMore(prevSate => !prevSate)
  }
  // const classes = useStyles();
  return (
    
    <div>
      <section 
        // className = {classes.SeeMoreBtn}
        style={{
          // marginTop:theme.spacing(1.5), 
          // marginBottom: theme.spacing(2),
          // fontSize:'16px', 
          // lineHeight:"150%",
          // letterSpacing:'0.24px',
          // fontFamily:'Montserrat',
          // fontWeight:'normal',
          // color:'#333333'
        }}
      >
        {/* {children} */}
        {readMore?children:text}
      </section>

      <Button 
        size='small' 
        variant='text' 

        onClick={toggleReadBtn}
        style={{
          marginTop: '12px', 
          marginBottom: '16px',
          fontSize:'14px', 
          fontWeight:'600', 
          textTransform:'capitalize',
          color: "blue",
        }}
        // endIcon={<ExpandMoreIcon />}
        >
        {readMore?'Read Less':'Read More'}
      </Button>
    
    </div>
  )
}

export default SeeMoreBtn